module.exports = [
    {display: '', value: ''},
    {display: 'FEMALE', value: 'FEMALE'},
    {display: 'MALE', value: 'MALE'},
    {display: 'NON-BINARY', value: 'NON BINARY'}
];